import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'

const TableChoosePhys = (props) => {
    const columns = [
        {
            title: '物理机名称',
            dataIndex: 'psName',
            component: <Table.ViewText />,
        },

        {
            title: '环境',
            dataIndex: 'psEnv',
            component: <Table.ViewText />,
        },

        {
            title: '内网IP',
            dataIndex: 'psIntranetIp',
            component: <Table.ViewText />,
        },

        {
            title: '公网IP',
            dataIndex: 'psInternetIp',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}

export default TableChoosePhys
